import "./VonageBackstageStyle.css";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { AppBar, Button, ButtonGroup, IconButton, Tabs, Tab, Tooltip, makeStyles } from "@material-ui/core";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import React, { useState, useEffect, useRef } from "react";
import { getUserInformation } from "../helpers/browser.helper";
import { connect } from "react-redux";
import { getKey } from "../helpers/UrlHelper";
import { clientTypeConstants } from "../interaction/constants/clientType.constants";
import { meetingService } from "../services/meeting/meeting.service";
import { ConnectionStatus } from "../digitalArena/components/fallbacks/ConnectionStatus";
import { ClientConnectionFallback, Loader } from "../digitalArena/utils/ClientConnectionFallback";
import NotAuthorized from "../components/NotAuthorized";
import VonageVideoClientModule from "../digitalArena/modules/Vonage/VonageVideoClientModule";
import StopIcon from "@material-ui/icons/Stop";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import PeopleIcon from "@material-ui/icons/People";
import SettingsIcon from "@material-ui/icons/Settings";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import MenuIcon from "@material-ui/icons/Menu";
import SystemLabel from "../system/SystemLabel/SystemLabel";
import Media from "react-media";
import { combineProps } from "../helpers/objectHelper";
import ChatModule from "../digitalArena/modules/ChatModule/ChatModule";
import ClientListModule from "../digitalArena/modules/ClientListModule/ClientListModule";
import VonageBackstageModeratorTab from "./Vonage/components/VonageBackstageModeratorTab";
// import VonageBackstageClientModule from "./Vonage/VonageBackstageClientModule";

const indicatorStyle = makeStyles((theme) => ({
  indicator: {
    backgroundColor: "rgb(22 88 197)",
  },
}));

const useStyles = makeStyles((theme) => ({
  // indicator: {
  //   backgroundColor: "rgb(41, 121, 255)",
  // },
  root: {
    opacity: 1,
  },
}));
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

var windowUpdateInterval = null;
var counter = null;

const defaultState = {
  loading: true,
  clientKey: "",
  error: null,
  connected: false,
  eventId: null,
  eventCode: null,
  connecting: true,
  forceDisc: false,
  clientName: "",
  clientInitial: "",
  notAuthorized: false,
  companyName: "",
  countdown: 0,
  parentEventCode: null,
  lang: "",
  personTypes: [],
  orderList: [],
  connectionList: [],
  userInfo: null,
  hubConnection: null,
  ip: "",
  initilized: false,
};

function VonageBackstage(props) {
  var [state, setState] = useState({ ...defaultState });
  const [countdown, setCountdown] = useState(0);
  const [onAir, setOnAir] = useState(false);
  const [view, setView] = useState("BACKSTAGE");
  const [onAirBtnDisabled, setOnAirButtonDisabled] = useState(false);
  const [viewBtnDisabled, setViewButtonDisabled] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [isRecording, setIsRecording] = useState(false);
  const [screenshareLayout, setScreenshareLayout] = useState("singleSpeaker");
  const [recordingArchiveId, setRecordingArchiveId] = useState(null);
  const [showHwSetup, setShowHardwareSetup] = useState(false);
  const [hardwareSetup, setHardwareSetup] = useState(null);
  const [isStudioStream, setIsStudioStream] = useState(false);
  const [isModerator, setIsModerator] = useState(true);
  const { dispatch, match, location, template, templateLoaded } = props;
  const prevState = usePrevious(state);
  const stateRef = useRef();
  const connectionTimerRef = useRef();
  const { clientName } = props;
  stateRef.current = state;
  useEffect(() => {
    // if (!window.location.href.includes("localhost")) {
    meetingService.getUserIp().then((ip) => {
      setState({ ...state, ip });
    });
    if (localStorage.getItem("vbss") && localStorage.getItem("vbss") === "true") {
      setIsStudioStream(true);
    }
    // } else {
    //   setState({ ...state, ip: "LOCALHOST" });
    // }

    return () => {
      if (windowUpdateInterval) {
        clearInterval(windowUpdateInterval);
        clearInterval(counter);
      }
    };
  }, []);
  useEffect(() => {
    localStorage.setItem("vbss", isStudioStream);
  }, [isStudioStream]);
  useEffect(() => {
    if (state.ip) {
      eventConfiguration();
    }
  }, [state.ip]);
  useEffect(() => {
    if (state.ip && state.eventId) {
      connectToHub();
    }
  }, [state.eventId]);
  useEffect(() => {
    const { hubConnection } = stateRef.current;
    if (hubConnection) {
      hubConnection.on("onArchiveRecordingStarted", onRecordingStarted);
      hubConnection.on("onArchiveRecordingStopped", onRecordingStopped);
      hubConnection.on("onChangeVonageScreenshareLayout", onChangeVonageScreenshareLayoutBackstage);
      hubConnection.on("onVonageHandshake", onVonageHandshake);
      hubConnection.on("onGetActiveConnections", onGetActiveConnections);
      hubConnection.on("onGetOrderList", onGetOrderList);
      hubConnection.on("onForceDisconnect", onForceDisconnect);
    }
    return () => {
      if (hubConnection) {
        hubConnection.off("onArchiveRecordingStarted", onRecordingStarted);
        hubConnection.off("onArchiveRecordingStopped", onRecordingStopped);
        hubConnection.off("onChangeVonageScreenshareLayout", onChangeVonageScreenshareLayoutBackstage);
        hubConnection.off("onVonageHandshake", onVonageHandshake);
        hubConnection.off("onGetActiveConnections", onGetActiveConnections);
        hubConnection.off("onGetOrderList", onGetOrderList);
        hubConnection.off("onForceDisconnect", onForceDisconnect);
      }
    };
  });

  useEffect(() => {
    const { connected, connecting, dismissConnectionLoss, forceDisc, hubConnection } = stateRef.current;

    if (connected == false && !forceDisc && prevState && prevState.connected == true && connecting == false) {
      tryReconnect();
      counter = setInterval(() => {
        setCountdown((prevCount) => prevCount + 1);
      }, 1000);
    } else if (countdown >= 60 && !connected && !forceDisc && prevState && prevState.connected == false) {
      setCountdown(0);
      setState({ ...stateRef.current, connecting: false });
      tryReconnect();
    } else if (connected == true && prevState && prevState.connected == false && !connecting && hubConnection && hubConnection.connectionState == 1) {
      if (counter) clearInterval(counter);
      setCountdown(0);
    }
  }, [state.connected, state.connecting, state.forceDisc, countdown, state.dismissConnectionLoss]);

  function insertParam(clientKey, lang, channel) {
    props.history.push({
      pathname: location.pathname,
      search:
        "?" +
        new URLSearchParams({
          clientKey: clientKey,
          lang,
        }).toString() +
        (channel ? "&" + new URLSearchParams({ channel }).toString() : ""),
    });
  }

  function tryReconnect() {
    const { connecting, connected } = stateRef.current;
    if (!connecting && !connected) {
      setState({ ...stateRef.current, loading: true, connecting: true });
      connectToHub();
    }
  }
  function toggleStudioStream() {
    setIsStudioStream(!isStudioStream);
  }
  function toggleRecording() {
    if (isRecording) {
      stopRecording();
    } else {
      startRecording();
    }
  }
  function startRecording() {
    const { hubConnection, eventId, channel } = stateRef.current;
    hubConnection.invoke("startArchiveRecording", eventId, channel);
    setIsRecording(true);
  }
  function onRecordingStarted(eventId, channel, archiveId) {
    if (eventId == stateRef.current.eventId && channel == stateRef.current.channel && archiveId) {
      setRecordingArchiveId(archiveId);
      setIsRecording(true);
    }
  }
  function stopRecording() {
    const { hubConnection, eventId, channel } = stateRef.current;
    if (isRecording && recordingArchiveId) {
      hubConnection.invoke("stopArchiveRecording", recordingArchiveId, eventId, channel);
      setIsRecording(false);
    }
  }
  function onRecordingStopped(archiveId) {
    if (recordingArchiveId == archiveId) {
      setRecordingArchiveId(null);
      setIsRecording(false);
    }
  }
  function eventConfiguration() {
    let eventId = match.params.id;
    const params = new URLSearchParams(location.search);
    const clientKey = params.get(getKey("clientkey", params));
    const lang = params.get(getKey("lang", params));
    const channel = params.get(getKey("channel", params));
    const newState = { ...state };

    if (lang) newState.lang = lang;
    if (clientKey) newState.clientKey = clientKey;
    newState.channel = channel || null;
    if (isNaN(eventId)) {
      newState.eventCode = eventId;
      setState(newState);
      meetingService.getEventId(eventId).then((res) => {
        setState({ ...stateRef.current, ...res });
      });
    } else {
      newState.eventId = parseInt(eventId);
      setState(newState);
    }
  }
  const onForceDisconnect = (status) => {
    const { hubConnection } = stateRef.current;
    const newState = {
      ...stateRef.current,
      connected: false,
      connecting: false,
    };
    if (status === "NOT_AUTHORIZED") newState.notAuthorized = true;
    else newState.forceDisc = true;
    setState(newState);
    hubConnection.stop();
  };
  function onGetActiveConnections(connectionList) {
    setState({ ...stateRef.current, connectionList });
  }
  function onGetOrderList(orderList) {
    setState({ ...stateRef.current, orderList });
  }
  const connectToHub = () => {
    const { eventId, eventCode, clientKey, ip, channel } = stateRef.current;
    setState({ ...stateRef.current, forceDisc: false });
    let hubConnection = stateRef.current.hubConnection;
    if (!hubConnection) hubConnection = new HubConnectionBuilder().withUrl("./ihub").build();
    hubConnection
      .start()
      .then(() => {
        hubConnection.onclose(() => {
          setState({ ...stateRef.current, connected: false });
        });
        let userInfo = { ...getUserInformation(), ipAddress: ip };
        setState({ ...stateRef.current, userInfo });
        const handshakeObj = {
          eventId: parseInt(eventId),
          clientType: clientTypeConstants.INTERACTION_VONAGE_SPEAKER,
          clientKey,
          channel: channel ? channel + "_BACKSTAGE" : "_BACKSTAGE",
          userGuid: null,
          userInfo,
        };
        hubConnection.invoke("vonageHandshake", handshakeObj);
        hubConnection.invoke("getActiveChatConnections", eventId).catch((err) => {});
        hubConnection.invoke("getActiveConnections", eventId, null, [clientTypeConstants.INTERACTION_VONAGE_SPEAKER, clientTypeConstants.INTERACTION_MEETING]);
      })
      .catch(function (e) {
        console.error(e);
      });
    setState({ ...stateRef.current, hubConnection });
  };

  function onVonageHandshake(response) {
    const { hubConnection, eventId, channel } = stateRef.current;
    document.title = response.eventName || "";
    const { success, askForPermissions, disableGroupChat, interactionAllowOneToOneChat, clientKey } = response;
    if (!success) {
      setState({
        ...stateRef.current,
        connected: false,
        init: true,
        loading: false,
      });
      return;
    }
    const lang = state.lang || response.lang || "swe";
    hubConnection.invoke("getOrderList", eventId);
    //Lägg in clientkey i url om den inte finns
    //lang
    insertParam(clientKey, lang, channel);
    setState({
      ...stateRef.current,
      connecting: false,
      connected: true,
      init: true,
      orderId: response.orderId,
      clientKey,
      loading: false,
      lang,
      initilized: true,
      eventName: response.eventName,
      eventCode: response.eventCode,
      clientKey: response.clientKey,
      clientName: response.clientName,
      personTypes: response.personTypes,
      clientInitial: response.clientInitial,
      parentEventCode: response.parentEventCode,
      companyName: response.companyName,
      linkedIn: response.linkedIn,
      title: response.title,
      profileImage: response.profileImage,
      disableGroupChat: response.disableGroupChat,
      interactionAllowOneToOneChat: response.interactionAllowOneToOneChat,
    });

    if (!connectionTimerRef.current) {
      connectionTimerRef.current = setInterval(() => {
        if (!stateRef.current.connected || !hubConnection || hubConnection.connectionState != 1) return;
        hubConnection.invoke("getActiveConnections", eventId, null, [clientTypeConstants.INTERACTION_VONAGE_SPEAKER, clientTypeConstants.INTERACTION_MEETING]).catch((err) => console.error(err));
      }, 5000);
    }
  }
  function connectionCount(filter) {
    const conns = stateRef.current.connectionList.filter((c) => c.type == filter).length;
    if (conns > 0) return <div className="tab-count">{conns > 999 ? `${conns}+` : conns}</div>;
    return null;
  }
  function toggleView(v, toggleOnAir) {
    setView(v);
    if (toggleOnAir) {
      setOnAir(!onAir);
    }
    setViewButtonDisabled(true);
    setOnAirButtonDisabled(true);
    setTimeout(() => {
      setViewButtonDisabled(false);
      setOnAirButtonDisabled(false);
    }, 3000);
  }
  function changeVonageScreenshareLayout(newLayout) {
    const { eventId, channel } = stateRef.current;
    stateRef.current.hubConnection.invoke("changeVonageScreenshareLayout", eventId, channel, newLayout);
    setScreenshareLayout(newLayout);
  }
  const onChangeVonageScreenshareLayoutBackstage = (newLayout) => {
    setScreenshareLayout(newLayout);
  };

  const classes = useStyles();
  const tabsClasses = indicatorStyle();
  const { forceDisc, notAuthorized, connected, connecting, initilized } = state;
  const settings = {
    backgroundColor: "transparent",
    backstage: true,
    allowFullscreen: false,
    showNametags: "HOVER",
    lockAspectRatio: true,
    aspectRatio: "16:9",
  };
  const api = {
    ...props,
    ...state,
    disableControls: onAirBtnDisabled || viewBtnDisabled || showHwSetup,
    channel: stateRef.current.channel ? stateRef.current.channel : undefined,
    view,
    onAir,
    isStudioStream,
    tryReconnect,
    toggleHardwareSetup: (s) => setShowHardwareSetup(s),
    setHardwareSetup: (hws) => setHardwareSetup(hws),
    hardwareSetup,
    settings: settings,
  };

  if (connecting && !initilized) return <Loader />;
  if (notAuthorized == true) return <NotAuthorized />;
  if (forceDisc && !connected) return <ClientConnectionFallback {...api} />;
  return (
    <div style={{ backgroundColor: "#222222" }}>
      <ConnectionStatus {...api} />
      <div style={{ display: "flex" }}>
        <AppBar className="backstage-header" style={{ padding: "7px 0px", display: "flex", flexDirection: "row", justifyContent: "center" }}>
          <span
            style={{
              // width: "20%",
              margin: "auto",
              textAlign: "center",
            }}
          >
            {stateRef.current.eventName} {stateRef.current.channel ? String.fromCharCode(8226) + " " + stateRef.current.channel : null}
          </span>
          <span
            style={{
              // width: "20%",
              margin: "auto",
              justifyContent: "right",
            }}
          >
            <Button
              startIcon={onAir ? <StopIcon /> : <PlayCircleFilledIcon />}
              className={"go-on-air-btn"}
              style={{
                background: onAirBtnDisabled || showHwSetup ? "#eee" : onAir ? "#d63a3a" : "rgb(22 88 197)",
                color: "#fff",
                fontSize: ".8rem",
                padding: "6px 14px",
              }}
              disabled={onAirBtnDisabled || showHwSetup}
              onClick={onAir ? () => toggleView("BACKSTAGE", true) : () => toggleView("LIVE", true)}
            >
              {onAir ? <SystemLabel name="StopStreaming" /> : null}
              {!onAir ? <SystemLabel name="StartStreaming" /> : null}
            </Button>
          </span>
          <ButtonGroup
            disableElevation
            variant="contained"
            className="backstage-btn-group"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={() => toggleView("LIVE")}
              disabled={viewBtnDisabled || showHwSetup || view === "LIVE"}
              variant={view == "LIVE" ? "contained" : ""}
              size="small"
              style={{ color: "#fff", border: 0, backgroundColor: view == "LIVE" ? "rgb(22 88 197)" : "transparent", borderRadius: view == "LIVE" ? 25 : undefined }}
            >
              <SystemLabel name="LiveView" />
            </Button>
            <Button
              disabled={onAir || viewBtnDisabled || view === "BACKSTAGE"}
              onClick={() => toggleView("BACKSTAGE")}
              variant={view == "BACKSTAGE" ? "contained" : ""}
              size="small"
              style={{
                color: "#fff",
                border: 0,
                opacity: onAir ? 0.6 : 1,
                backgroundColor: view == "BACKSTAGE" ? "rgb(22 88 197)" : "transparent",
                borderRadius: view == "BACKSTAGE" ? 25 : undefined,
              }}
            >
              <SystemLabel name="BackstageView" />
            </Button>
          </ButtonGroup>
          <span
            style={{
              // width: "20%",
              display: "flex",
              margin: "auto",
              justifyContent: "right",
            }}
          >
            {isRecording ? <div className="on-air-icon" style={{ margin: "5px 10px", width: "10px", height: "10px" }} /> : null}
            {isRecording ? <SystemLabel name="Recording" /> : null}
          </span>
          <span
            style={{
              // width: "20%",
              margin: "auto",
              justifyContent: "left",
            }}
          >
            <Button
              className={"go-on-air-btn"}
              // className="moderator-page-to-btn"
              style={{
                background: "rgb(22 88 197)",
                color: "#fff",
                fontSize: ".8rem",
                padding: "6px 14px",
              }}
              onClick={() =>
                window.open(`${window.location.origin}${!window.location.toString().includes("localhost") ? "/interaction" : ""}/session/stage/${stateRef.current.eventCode}?lang=${stateRef.current.lang}`, "_blank")
              }
            >
              <AllInboxIcon className="pop-list-icon" />
              <SystemLabel name="StagePage" />
            </Button>
          </span>
          <span
            className="mobile-menu-wrap"
            style={{
              // width: "20%",
              display: "flex",
              margin: "auto",
              textAlign: "center",
            }}
          >
            <span className="vbs-clientName" style={{ margin: "auto" }}>
              {stateRef.current.clientName || "Gäst"}
            </span>

            <IconButton className="mobile-menu-btn" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
              <MenuIcon />
            </IconButton>
          </span>
        </AppBar>
        <div
          className="backstage"
          // id="vonage-module-wrap"
          // onMouseMove={toggleControlbar}
          style={{
            backgroundColor: "#222",
            // display: view == "LIVE" ? "flex" : "none",
            border: onAir ? "2px solid red" : "2px solid #222",
          }}
        >
          {view == "LIVE" ? <VonageVideoClientModule {...api} /> : null}
          {view == "BACKSTAGE" ? <VonageVideoClientModule {...api} channel={stateRef.current.channel ? stateRef.current.channel + "_BACKSTAGE" : "_BACKSTAGE"} /> : null}
        </div>
        <Media
          queries={{
            desktop: "(min-width: 1024px)",
          }}
        >
          {(matches) => (
            <>
              {matches.desktop || (!matches.desktop && isSidebarOpen) ? (
                <div className={"backstage-chat-wrapper" + (isSidebarOpen ? " sidebar-wide-sm" : "")}>
                  <AppBar className="backstage-header chat" position="static">
                    <Tabs classes={tabsClasses} value={activeTab} onChange={(e, val) => setActiveTab(val)} aria-label="tabs">
                      <Tab
                        className={classes.root}
                        label={
                          <Tooltip title={<SystemLabel name="Chat" />}>
                            <span style={{ fontSize: 13 }}>
                              <ChatBubbleIcon style={{ fontSize: 18 }} />
                            </span>
                          </Tooltip>
                        }
                        {...a11yProps(0)}
                        style={{ minWidth: "25%", maxWidth: "25%", flexGrow: 1 }}
                      />
                      <Tab
                        className={classes.root}
                        label={
                          <Tooltip title={<SystemLabel name="Speaker" />}>
                            <span style={{ fontSize: 13, display: "flex" }}>
                              <RecordVoiceOverIcon style={{ fontSize: 18 }} /> {connectionCount(clientTypeConstants.INTERACTION_VONAGE_SPEAKER)}
                            </span>
                          </Tooltip>
                        }
                        {...a11yProps(1)}
                        style={{ minWidth: "25%", maxWidth: "25%", flexGrow: 1 }}
                      />
                      <Tab
                        className={classes.root}
                        label={
                          <Tooltip title={<SystemLabel name="Visitors" />}>
                            <span style={{ fontSize: 13, display: "flex" }}>
                              <PeopleIcon style={{ fontSize: 18 }} /> {connectionCount(clientTypeConstants.INTERACTION_MEETING)}
                            </span>
                          </Tooltip>
                        }
                        {...a11yProps(2)}
                        style={{ minWidth: "25%", maxWidth: "25%", flexGrow: 1 }}
                      />
                      {isModerator ? (
                        <Tab
                          className={classes.root}
                          label={
                            <Tooltip title={<SystemLabel name="Moderator" />}>
                              <span style={{ fontSize: 13 }}>
                                <SettingsIcon style={{ fontSize: 18 }} />
                              </span>
                            </Tooltip>
                          }
                          {...a11yProps(3)}
                          style={{ minWidth: "25%", maxWidth: "25%", flexGrow: 1 }}
                        />
                      ) : null}
                    </Tabs>
                  </AppBar>
                  <TabPanel value={activeTab} index={0}>
                    <ChatModule {...combineProps([props, state, { connectionList: [], settings: { showUserProfileImage: false }, backstage: true }])} />
                  </TabPanel>
                  <TabPanel value={activeTab} index={1}>
                    {activeTab == 1 ? <ClientListModule {...combineProps([props, state, { backstage: true, backstageConns: true }])} /> : null}
                  </TabPanel>
                  <TabPanel value={activeTab} index={2}>
                    {activeTab == 2 ? <ClientListModule {...combineProps([props, state, { backstage: true, backstageConns: false }])} /> : null}
                  </TabPanel>
                  {isModerator ? (
                    <TabPanel value={activeTab} index={3}>
                      <VonageBackstageModeratorTab
                        screenshareLayout={screenshareLayout}
                        isStudioStream={isStudioStream}
                        toggleStudioStream={toggleStudioStream}
                        isRecording={isRecording}
                        toggleRecording={toggleRecording}
                        changeScreenshareLayout={changeVonageScreenshareLayout}
                      />
                    </TabPanel>
                  ) : null}
                </div>
              ) : null}
            </>
          )}
        </Media>
      </div>
    </div>
  );
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} style={{ height: "100%" }} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {children}
    </div>
  );
}
function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps)(VonageBackstage);
